import {Component, OnInit} from '@angular/core';
import {LoadingService} from '@shared/services/loading.service';
import {PrimeNG} from 'primeng/config';
import {TranslateService} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {RouterOutlet} from '@angular/router';
import {ToastModule} from 'primeng/toast';
import {ProgressSpinnerModule} from 'primeng/progressspinner';

import {Observable} from 'rxjs';
import {WhitelabelService} from '@app/admin/whitelabel/service/whitelabel.service';
import {Store} from '@ngrx/store';
import {setWhitelabel} from '@shared/store/app/app.action';
import {selectWhitelabelConfig} from '@shared/store/app/app.selector';
import {injectWhitelabelStyles} from '@shared/utilities/whitelabel';
import {FcmService} from '@shared/services/fcm.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterOutlet, ToastModule, ProgressSpinnerModule]
})
export class AppComponent implements OnInit {
  title = 'GPS Tracking & Fleet Management';
  loading$: Observable<boolean> = null;

  initializing: boolean = true;

  constructor(
    private loadingService: LoadingService,
    private primeng: PrimeNG,
    private translateService: TranslateService,
    private whitelabelService: WhitelabelService,
    private store: Store,
    private fcmService: FcmService,
  ) {
    this.loading$ = this.loadingService.loading$;
  }

  ngOnInit() {
    this.translateService.setDefaultLang('en');
    this.loadWhitelabelConfig();
    this.store.select(selectWhitelabelConfig).subscribe((config) => {
      injectWhitelabelStyles(config?.['theme']);
    });
    this.fcmService.message$.subscribe(msg => {

    });
  }

  hideLoader() {
    let loading = document.getElementById('loading');
    if (loading) {
      setTimeout(() => {
        loading.style.display = 'none';
        document.querySelector('input')?.focus();
      }, 500);
    }
  }

  loadWhitelabelConfig() {
    this.initializing = true;
    let hostname = document.location.hostname;
    let s = this.whitelabelService
      .getWhitelabelDomainInfo(hostname)
      .subscribe((res) => {
        if (res.errors) {
          // fallback to generic mode
          this.store.dispatch(
            setWhitelabel({
              whitelabelDomainInfo: null,
              whitelabelSource: null,
            }),
          );
        } else {
          // load info to store
          let data = res.data.getWhitelabelInfo;
          if (data) {
            this.store.dispatch(
              setWhitelabel({
                whitelabelDomainInfo: data,
                whitelabelSource: 'host',
              }),
            );
          }
        }
        this.initializing = false;
        s.unsubscribe();
        this.hideLoader();
      });
  }

  translate(lang: string) {
    this.translateService.use(lang);
    this.translateService
      .get('primeng')
      .subscribe((res) => this.primeng.setTranslation(res));
  }
}
